/**
 * js-tabs functionality
 */

function initTabs() {
  const tabsContainers = document.querySelectorAll('.js-tabs');

  tabsContainers.forEach((container) => {
    const links = container.querySelectorAll('.js-tablist__link');

    links.forEach((link) => {
      // Add click event listener to each tab link
      link.addEventListener('click', (event) => {
        event.preventDefault();

        const targetId = link.getAttribute('href');
        if (!targetId || !targetId.startsWith('#')) return;

        const targetContent = container.querySelector(targetId);
        if (!targetContent) return;

        // De-select all tab links and hide all tab contents in this container
        links.forEach((l) => {
          l.setAttribute('aria-selected', 'false');
          l.removeAttribute('data-selected');

          const tId = l.getAttribute('href');
          if (tId && tId.startsWith('#')) {
            const content = container.querySelector(tId);
            if (content) {
              content.setAttribute('aria-hidden', 'true');
            }
          }
        });

        // Select the clicked tab link and show the target content
        link.setAttribute('aria-selected', 'true');
        link.setAttribute('data-selected', '1');
        targetContent.setAttribute('aria-hidden', 'false');
      });
    });

    // Initialize: Set aria-selected/aria-hidden attributes properly if not set
    const activeLink = container.querySelector('.js-tablist__link[aria-selected="true"]') ||
      container.querySelector('.js-tablist__link[data-selected="1"]') ||
      links[0];

    if (activeLink) {
      links.forEach((l) => {
        const isSelected = l === activeLink;
        l.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        if (isSelected) {
          l.setAttribute('data-selected', '1');
        } else {
          l.removeAttribute('data-selected');
        }

        const tId = l.getAttribute('href');
        if (tId && tId.startsWith('#')) {
          const content = container.querySelector(tId);
          if (content) {
            content.setAttribute('aria-hidden', isSelected ? 'false' : 'true');
          }
        }
      });
    }
  });
}

// Initialize on DOMContentLoaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTabs);
} else {
  initTabs();
}

// Since Shopify Section rendering might replace DOM, we should support re-initialization
document.addEventListener('shopify:section:load', initTabs);
